<template>
  <div
    class="d2-layout-header-aside-group"
    :style="styleLayoutMainGroup"
    :class="{ grayMode: grayActive, 'is-open-side': asideCollapse }"
  >
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <div
        class="d2-theme-header"
        :style="{
          opacity: this.searchActive ? 0.5 : 1
        }"
        flex-box="0"
        flex>
        <div
          class="logo-group"
          flex-box="0"
        >
          <img
            v-if="asideCollapse" v-show="hideSideFlag"
            :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/icon-only.png`"
          />
          <img
            v-else
            :src="
              `${$baseUrl}image/theme/${themeActiveSetting.name}/logo/all.png`
            "
          />
        </div>
        <div class="toggle-aside-btn" @click="handleToggleAside" flex-box="0">
          <i style="font-size:24px;" class="el-icon-s-unfold" v-if="asideCollapse" />
          <i style="font-size:24px;" class="el-icon-s-fold" v-else/>
        </div>
        <d2-menu-header flex-box="1" />
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" flex-box="0">
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
          <el-dropdown trigger="hover">
            <span class="el-dropdown-link">
              <i class="fa fa-windows" aria-hidden="true"></i>子系统<i
                class="el-icon-arrow-down el-icon--right"
              ></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="sub-system">
              <el-dropdown-item
                v-for="(item, index) in systemList"
                :key="index"
                @click.native="gotoChildSystem(item.linkUrl)"
                >{{ item.linkServerName }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <d2-header-search @click="handleSearchClick" />
          <d2-header-error-log />
          <d2-header-fullscreen />
          <d2-header-theme />
          <d2-header-size />
          <d2-header-user @compelLogin="openCompelLogin" />
        </div>
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 侧边栏 -->
        <div
          flex-box="0"
          ref="aside"
          class="d2-theme-container-aside"
          :style="{
            width: asideCollapse ? asideWidthCollapse : asideWidth,
            opacity: this.searchActive ? 0.5 : 1,
            display: hideSideFlag ? 'block' : 'none',
          }"
        >
        <div style="position:absolute;bottom:30px;margin-left:12px;z-index:1001;padding:4px;" v-show="hideSideFlag && asideCollapse" @click.stop="hideSide">
            <i class="el-icon-d-arrow-left" />
          </div>
          <div class="side-logo-group">
            <!-- <img
              width="100%"
              :src="
                `${$baseUrl}image/theme/${themeActiveSetting.name}/logo/icon-only.png`
              "
            /> -->
          </div>
        <div style="position:relative;height:100%;">
          <d2-menu-side :collapse="asideCollapse"/>
        </div>
        </div>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex>
          <!-- 搜索 -->
          <transition name="fade-scale">
            <div
              v-show="searchActive"
              class="d2-theme-container-main-layer"
              flex="dir:top"
            >
              <d2-panel-search ref="panelSearch" @close="searchPanelClose" />
            </div>
          </transition>
          <!-- 内容 -->
          <transition name="fade-scale">
            <div
              v-show="!searchActive"
              class="d2-theme-container-main-layer"
              flex="dir:top"
            >
              <!-- tab -->
              <div class="d2-theme-container-main-header" flex-box="0">
                <d2-tabs />
              </div>
              <!-- 页面 -->
              <div class="d2-theme-container-main-body" flex-box="1">
                <transition :name="transitionActive ? 'fade-transverse' : ''">
                  <keep-alive :include="keepAlive">
                    <router-view />
                  </keep-alive>
                </transition>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!-- 强制登录弹框 -->
    <el-dialog
      title="提示"
      class="compelLogin"
      :visible.sync="dialogVisible"
      width="550px"
    >
      <el-card shadow="never">
        <div
          class="page-login--content-main z-index"
          flex="dir:top main:center cross:center"
        >
          <!-- 表单 -->
          <div class="page-login--form">
            <el-card shadow="never">
              <div
                slot="header"
                class="login-header"
                style="text-align: center;"
              >
                <img :src="logo" class="logo-img" height="32" />
              </div>

              <div class="loginForm-body">
                <el-form
                  ref="loginForm"
                  label-position="top"
                  :rules="rules"
                  :model="formLogin"
                  size="default"
                >
                  <el-form-item prop="loginName">
                    <el-input
                      type="text"
                      v-model="formLogin.loginName"
                      placeholder="用户名"
                      @keyup.enter.native="submit"
                      style="height: 50px;"
                    >
                      <i slot="prepend" class="fa fa-user-circle-o"></i>
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input
                      type="password"
                      v-model="formLogin.password"
                      placeholder="密码"
                      @keyup.enter.native="submit"
                      style="height: 50px;"
                    >
                      <i slot="prepend" class="fa fa-keyboard-o"></i>
                    </el-input>
                  </el-form-item>
                  <el-button
                    @click="submit"
                    :loading="loginLoading"
                    type="primary"
                    class="button-login"
                    style="height: 50px;"
                    >{{ loginLoading ? '登录中...' : '强制登录' }}</el-button
                  >
                </el-form>
              </div>
            </el-card>
          </div>
        </div>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import { getSubsystemMenu } from '@/api/systemPrivilege/account'
import logo from '../../assets/image/ui/logo.png'
import d2MenuSide from './components/menu-side'
import d2MenuHeader from './components/menu-header'
import d2Tabs from './components/tabs'
import d2HeaderFullscreen from './components/header-fullscreen'
import d2HeaderSearch from './components/header-search'
import d2HeaderSize from './components/header-size'
import d2HeaderTheme from './components/header-theme'
import d2HeaderUser from './components/header-user'
import d2HeaderErrorLog from './components/header-error-log'
import { mapState, mapGetters, mapActions } from 'vuex'
import mixinSearch from './mixins/search'
import util from '@/libs/util.js'
export default {
  name: 'd2-layout-header-aside',
  mixins: [mixinSearch],
  components: {
    d2MenuSide,
    d2MenuHeader,
    d2Tabs,
    d2HeaderFullscreen,
    d2HeaderSearch,
    d2HeaderSize,
    d2HeaderTheme,
    d2HeaderUser,
    d2HeaderErrorLog
  },
  data() {
    // 匹配访问来源是否有10000端口号（支持外网访问时用），若有，需给各项目访问入口URL也增加10000端口号。
    let urlPort = window.location.port;
    urlPort = urlPort && urlPort.length && urlPort === '10000' ? `:${window.location.port}` : '';

    return {
      hideSideFlag: true,
      // 表单
      formLogin: {
        loginName: '',
        password: ''
      },
      // 校验
      rules: {
        loginName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loginLoading: false, // 登录是为true 登录失败为false
      logo: logo,
      dialogVisible: false,
      // 强制登录
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '45px',
      systemList: []
    }
  },
  computed: {
    ...mapState('d2admin', {
      keepAlive: state => state.page.keepAlive,
      grayActive: state => state.gray.active,
      transitionActive: state => state.transition.active,
      asideCollapse: state => state.menu.asideCollapse
    }),
    ...mapGetters('d2admin', {
      themeActiveSetting: 'theme/activeSetting'
    }),
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup() {
      return {
        ...(this.themeActiveSetting.backgroundImage
          ? {
              backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`
            }
          : {})
      }
    }
  },
  created () {
    // 获取子系统菜单
    getSubsystemMenu({ isShow: 1 }).then(res => {
      if (res.data && res.data.serverConfigItems) {
        this.systemList = res.data.serverConfigItems.filter((item) => {
          return item.linkServerName !== '鉴权系统'
        })
      }
    })
    let innerWidth = window.innerWidth

    if (innerWidth < 768 && !this.asideCollapse) {
      this.asideCollapseToggle()
    }
  },
  methods: {
    ...mapActions('d2admin/menu', ['asideCollapseToggle']),
    ...mapActions('d2admin/account', ['compelLogin']),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside () {
      this.hideSideFlag = true
      this.asideCollapseToggle()
    },
    hideSide () {
      this.hideSideFlag = false
    },
    gotoChildSystem(linkUrl) {
      // var APP_NODE_ENV = item.APP_NODE_ENV
      // var url = ''
      // switch (APP_NODE_ENV) {
      //   case 'development':
      //     url = item.developmentUrl
      //     break
      //   case 'devtest':
      //     url = item.devtestUrl
      //     break
      //   case 'advance':
      //     url = item.advanceUrl
      //     break
      //   case 'production':
      //     url = item.productionUrl
      //     break
      //   case 't1':
      //     url = item.t1Url
      //     break
      //   case 't2':
      //     url = item.t2Url
      //     break
      //   case 't3':
      //     url = item.t3Url
      //     break
      //   default:
      //     return ''
      // }
      window.open(linkUrl)
    },
    // 强制登录
    openCompelLogin() {
      // this.$emit()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.loginForm.resetFields()
      })
    },
    // 强制登录
    submit() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // 登录
          let router = this.$route
          // let serverName = 'oauth-server'
          // let ru = util.getUrlPara(window.location.href, 'ru')
          // if (!!ru) {
          //   if (ru.indexOf('product') > -1) {
          //     serverName = 'product-server'
          //   } else if (ru.indexOf('workflow') > -1) {
          //     serverName = 'workflow-server'
          //   } else if (ru.indexOf('coupon') > -1) {
          //     serverName = 'coupon-server'
          //   } else if (ru.indexOf('risk') > -1) {
          //     serverName = 'risk-system-server'
          //   }
          // }
          this.loginLoading = true
          this.compelLogin({
            vm: this,
            loginName: this.formLogin.loginName,
            password: this.formLogin.password
            // serverName: serverName
          })
            .then(res => {
              // if (ru) {
              //   window.location.href = decodeURIComponent(ru)
              //   return
              // }
              // 重定向对象不存在则返回顶层路径
              this.$router.replace(this.$route.query.redirect || '/')
              // this.$router.replace({
              //   path: router.path,
              //   query: router.query
              // })
              this.dialogVisible = false
              this.loginLoading = false
            })
            .catch(err => {
              console.log(err)
              this.loginLoading = false
            })
        } else {
          // 登录表单校验失败
          // this.$message.error('表单校验失败')
        }
      })
    }
  }
}
</script>

<style lang="scss">
// 注册主题
@import '~@/assets/style/theme/register.scss';
.el-dialog__wrapper.compelLogin {
  .el-dialog__header {
    display: none;
  }
  // 登录表单
  .page-login--form {
    width: 590px;
    height: 350px;
    background: #fff;
    // 去除默认样式 start
    .el-card.is-always-shadow {
      border: none;
      box-shadow: none;
      background: #fff;
    }
    .el-card__header,
    .el-card__body {
      border: none;
      z-index: 10;
      background: #fff;
    }
    // 去除默认样式 end
    .loginForm-body {
      background: #fff;
    }
    // 切换登录和扫码
    .change-icon {
      position: absolute;
      top: 0;
      right: 0;
      height: 73px;
      width: 73px;
      img {
        height: 73px;
        width: 73px;
      }
    }
    // 卡片
    .el-card {
      border: none;
      margin-bottom: 15px;
      .el-card__body {
        padding: 30px 120px 40px 120px;
        background: #fff;
        border: none;
      }
    }
    .el-input {
      input {
        height: 50px;
      }
    }
    // 登录按钮
    .button-login {
      width: 100%;
    }
    // 登陆选项
    .page-login--options {
      margin: 0px;
      padding: 0px;
      font-size: 14px;
      color: $color-primary;
      margin-bottom: 15px;
      font-weight: bold;
    }
    .page-login--quick {
      width: 100%;
    }
    // 输入框左边的图表区域缩窄
    .el-input-group__prepend {
      padding: 0px 14px;
    }
    .login-code {
      height: 40px - 2px;
      display: block;
      margin: 0px -20px;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
  }
}
.sub-system {
  max-height: 90vh;
  overflow: auto;
  .el-dropdown-menu__item {
    white-space: nowrap;
  }
}
</style>
